import React, { useState } from 'react'
import MobileFirstMenu from './MobileFirstMenu'
import MobileSecondMenu from './MobileSecondMenu'

const MobileMenu = ({ 
  ifSubMenuShow, 
  setIfSubMenuShow, 
  getLinkUrl, 
  shopUrl, 
  dontfixed,  
  guidesList, 
  categoriesList, 
  productsAll,
  ifShowLocalNav,
  cusBackgroundColor = 'rgba(255,255,255,1)',
  cusBackdropFilter = 40,
  headerTextBlack = true
}) => {
  const [ifSecondMenuShow, setIfSecondMenuShow] = useState(false)
  const [secTitle, setSecTitle] = useState('')
  const handleShowSecondMenu = (title, key) => {
    console.log(778899, title, key)
    if (key === "products") {
      setIfSecondMenuShow(true)
      setSecTitle(title)
    } else {
      setIfSecondMenuShow(false)
    }
  }


  return (
    <>
      {ifSecondMenuShow ? 
        <MobileSecondMenu 
          categoriesList={categoriesList} 
          productsAll={productsAll} 
          secTitle={secTitle} 
          handleShowSecondMenu={handleShowSecondMenu} 
          ifSubMenuShow={ifSubMenuShow} 
          setIfSubMenuShow={setIfSubMenuShow} 
          getLinkUrl={getLinkUrl} 
          shopUrl={shopUrl} 
          dontfixed={dontfixed} 
          ifShowLocalNav={ifShowLocalNav} /> :
        <MobileFirstMenu 
          guidesList={guidesList} 
          handleShowSecondMenu={handleShowSecondMenu} 
          ifSubMenuShow={ifSubMenuShow} 
          setIfSubMenuShow={setIfSubMenuShow} 
          getLinkUrl={getLinkUrl} 
          shopUrl={shopUrl} 
          ifShowLocalNav={ifShowLocalNav}
          cusBackgroundColor={cusBackgroundColor}
          cusBackdropFilter={cusBackdropFilter}
          headerTextBlack={headerTextBlack}/>
      }
    </>
  )
}

export default MobileMenu
